// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { collection, addDoc, Timestamp } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig';
// import './Wishlist.css';

// const Wishlist = () => {
//   const [wishlistItems, setWishlistItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [sortBy, setSortBy] = useState('name');
//   const [sortOrder, setSortOrder] = useState('asc');

//   useEffect(() => {
//     try {
//       // Load wishlist items from localStorage
//       const storedItems = localStorage.getItem('wishListItems');
//       if (storedItems) {
//         const parsedItems = JSON.parse(storedItems);
//         setWishlistItems(Array.isArray(parsedItems) ? parsedItems : []);
//       } else {
//         setWishlistItems([]);
//       }
//     } catch (error) {
//       console.error("Error loading wishlist items:", error);
//       setError("Error loading wishlist items. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     // Sort items whenever sort criteria changes
//     if (wishlistItems.length > 0) {
//       const sortedItems = [...wishlistItems].sort((a, b) => {
//         let comparison = 0;
        
//         // Handle different sort fields
//         switch(sortBy) {
//           case 'name':
//             comparison = a.name.localeCompare(b.name);
//             break;
//           case 'price':
//             comparison = (a.price || 0) - (b.price || 0);
//             break;
//           case 'date':
//             // If you have added date property, use it; otherwise fallback to name
//             comparison = a.name.localeCompare(b.name);
//             break;
//           default:
//             comparison = a.name.localeCompare(b.name);
//         }
        
//         // Apply sort order
//         return sortOrder === 'asc' ? comparison : -comparison;
//       });
      
//       setWishlistItems(sortedItems);
//     }
//   }, [sortBy, sortOrder]);

//   const handleRemoveItem = (productId) => {
//     try {
//       const updatedItems = wishlistItems.filter(item => item.id !== productId);
//       setWishlistItems(updatedItems);
//       localStorage.setItem('wishListItems', JSON.stringify(updatedItems));
      
//       // Dispatch event to update floating action button
//       const event = new Event('wishlistUpdated');
//       window.dispatchEvent(event);
//     } catch (error) {
//       console.error("Error removing item from wishlist:", error);
//       setError("Error removing item. Please try again.");
//     }
//   };

//   const handleAddToCart = async (product) => {
//     try {
//       // Get existing cart
//       const existingCart = localStorage.getItem('cartItems');
//       let cartItems = [];
      
//       if (existingCart) {
//         cartItems = JSON.parse(existingCart);
//         if (!Array.isArray(cartItems)) cartItems = [];
//       }
      
//       // Check if item already exists in cart
//       const existingItemIndex = cartItems.findIndex(item => item.id === product.id);
      
//       if (existingItemIndex >= 0) {
//         // Increment quantity if already in cart
//         cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
//       } else {
//         // Add new item to cart
//         const cartItem = {
//           id: product.id,
//           name: product.name,
//           price: product.price || 0,
//           quantity: 1,
//           imageUrl: product.imageUrl || product.image,
//           image: product.imageUrl || product.image,
//           deliverySpeed: product.deliverySpeed || 'normal',
//           originalDeliverySpeed: product.deliverySpeed || 'normal'
//         };
        
//         cartItems.push(cartItem);
//       }
      
//       // Save updated cart to localStorage
//       localStorage.setItem('cartItems', JSON.stringify(cartItems));
      
//       // Also save to Firestore if user is logged in
//       try {
//         const authToken = localStorage.getItem('authToken');
//         if (authToken) {
//           // Get user info
//           const userInfo = JSON.parse(localStorage.getItem('userData') || '{}');
//           const userId = userInfo.uid;
          
//           if (userId) {
//             // Add to cart history in Firestore
//             await addDoc(collection(db, 'cartHistory'), {
//               userId: userId,
//               productId: product.id,
//               productName: product.name,
//               price: product.price || 0,
//               quantity: 1,
//               addedAt: Timestamp.now(),
//               source: 'wishlist'
//             });
//           }
//         }
//       } catch (firestoreError) {
//         console.error("Error saving to Firestore:", firestoreError);
//         // Continue execution even if Firestore fails
//       }
      
//       // Dispatch cart updated event
//       const event = new Event('cartUpdated');
//       window.dispatchEvent(event);
      
//       // Show success message or toast notification
//       alert(`${product.name} added to cart!`);
//     } catch (error) {
//       console.error("Error adding item to cart:", error);
//       setError("Error adding item to cart. Please try again.");
//     }
//   };

//   const handleClearAll = () => {
//     setWishlistItems([]);
//     localStorage.setItem('wishListItems', JSON.stringify([]));
    
//     // Dispatch event to update floating action button
//     const event = new Event('wishlistUpdated');
//     window.dispatchEvent(event);
//   };

//   const handleSortChange = (e) => {
//     setSortBy(e.target.value);
//   };

//   const toggleSortOrder = () => {
//     setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//   };

//   if (loading) {
//     return (
//       <div className="wishlist-container">
//         <h1 className="wishlist-title">MY WISHLIST</h1>
//         <div className="loading-message">Loading wishlist items...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="wishlist-container">
//         <h1 className="wishlist-title">MY WISHLIST</h1>
//         <div className="error-message">{error}</div>
//       </div>
//     );
//   }

//   if (wishlistItems.length === 0) {
//     return (
//       <div className="wishlist-container">
//         <h1 className="wishlist-title">MY WISHLIST</h1>
//         <div className="empty-wishlist">
//           <p>Your wishlist is empty.</p>
//           <Link to="/products" className="browse-products-btn">Browse Products</Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="wishlist-container">
//       <div className="wishlist-header">
//         <h1 className="wishlist-title">MY WISHLIST</h1>
//         <div className="wishlist-actions">
//           <div className="sort-controls">
//             <select 
//               className="sort-select" 
//               value={sortBy} 
//               onChange={handleSortChange}
//               aria-label="Sort wishlist by"
//             >
//               <option value="name">Sort by Name</option>
//               <option value="price">Sort by Price</option>
//             </select>
//             <button 
//               className="sort-order-btn" 
//               onClick={toggleSortOrder}
//               aria-label={`Sort ${sortOrder === 'asc' ? 'ascending' : 'descending'}`}
//             >
//               {sortOrder === 'asc' ? '↑' : '↓'}
//             </button>
//           </div>
//           <button className="clear-all-btn" onClick={handleClearAll}>
//             Clear All
//           </button>
//         </div>
//       </div>

//       <div className="wishlist-items">
//         {wishlistItems.map(item => (
//           <div key={item.id} className="wishlist-item">
//             <div className="wishlist-item-image">
//               <img 
//                 src={item.imageUrl || item.image || "/images/product-placeholder.jpg"} 
//                 alt={item.name}
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.src = "/images/product-placeholder.jpg";
//                 }}
//               />
//             </div>
//             <div className="wishlist-item-details">
//               <h3 className="wishlist-item-name">{item.name}</h3>
//               <p className="wishlist-item-price">₹{parseFloat(item.price).toFixed(2)}</p>
//               <p className="wishlist-item-desc">{item.description || "No description available."}</p>
              
//               <div className="delivery-info">
//                 {item.deliverySpeed === 'quick' && (
//                   <span className="delivery-badge quick">QUICK DELIVERY</span>
//                 )}
//                 {item.deliverySpeed === 'express' && (
//                   <span className="delivery-badge express">EXPRESS DELIVERY</span>
//                 )}
//                 {(item.deliverySpeed === 'normal' || !item.deliverySpeed) && (
//                   <span className="delivery-badge normal">NORMAL DELIVERY</span>
//                 )}
//               </div>
//             </div>
//             <div className="wishlist-item-actions">
//               <button 
//                 className="add-to-cart-btn"
//                 onClick={() => handleAddToCart(item)}
//               >
//                 Add to Cart
//               </button>
//               <button 
//                 className="remove-wishlist-btn"
//                 onClick={() => handleRemoveItem(item.id)}
//                 aria-label={`Remove ${item.name} from wishlist`}
//               >
//                 Remove
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Wishlist;



import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import './Wishlist.css';

const Wishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const [cartItems, setCartItems] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });

const navigate = useNavigate();

  useEffect(() => {
    try {
      // Load wishlist items from localStorage
      const storedItems = localStorage.getItem('wishListItems');
      if (storedItems) {
        const parsedItems = JSON.parse(storedItems);
        setWishlistItems(Array.isArray(parsedItems) ? parsedItems : []);
      } else {
        setWishlistItems([]);
      }

      // Load cart items to track which products are already in cart
      const storedCart = localStorage.getItem('cartItems');
      if (storedCart) {
        const parsedCart = JSON.parse(storedCart);
        const cartMap = {};
        
        if (Array.isArray(parsedCart)) {
          parsedCart.forEach(item => {
            cartMap[item.id] = item.quantity || 0;
          });
        }
        
        setCartItems(cartMap);
      }
    } catch (error) {
      console.error("Error loading wishlist items:", error);
      setError("Error loading wishlist items. Please try again.");
    } finally {
      setLoading(false);
    }

    // Listen for cart updates
    const handleCartUpdate = () => {
      const storedCart = localStorage.getItem('cartItems');
      if (storedCart) {
        const parsedCart = JSON.parse(storedCart);
        const cartMap = {};
        
        if (Array.isArray(parsedCart)) {
          parsedCart.forEach(item => {
            cartMap[item.id] = item.quantity || 0;
          });
        }
        
        setCartItems(cartMap);
      } else {
        setCartItems({});
      }
    };

    window.addEventListener('cartUpdated', handleCartUpdate);
    
    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, []);

  useEffect(() => {
    // Sort items whenever sort criteria changes
    if (wishlistItems.length > 0) {
      const sortedItems = [...wishlistItems].sort((a, b) => {
        let comparison = 0;
        
        // Handle different sort fields
        switch(sortBy) {
          case 'name':
            comparison = a.name.localeCompare(b.name);
            break;
          case 'price':
            comparison = (a.price || 0) - (b.price || 0);
            break;
          case 'date':
            // If you have added date property, use it; otherwise fallback to name
            comparison = a.name.localeCompare(b.name);
            break;
          default:
            comparison = a.name.localeCompare(b.name);
        }
        
        // Apply sort order
        return sortOrder === 'asc' ? comparison : -comparison;
      });
      
      setWishlistItems(sortedItems);
    }
  }, [sortBy, sortOrder]);

  const handleRemoveItem = (productId) => {
    try {
      const updatedItems = wishlistItems.filter(item => item.id !== productId);
      setWishlistItems(updatedItems);
      localStorage.setItem('wishListItems', JSON.stringify(updatedItems));
      
      // Dispatch event to update floating action button
      const event = new Event('wishlistUpdated');
      window.dispatchEvent(event);
    } catch (error) {
      console.error("Error removing item from wishlist:", error);
      setError("Error removing item. Please try again.");
    }
  };

  const handleAddToCart = async (product) => {
    try {
      // Get existing cart
      const existingCart = localStorage.getItem('cartItems');
      let cartArray = [];
      
      if (existingCart) {
        cartArray = JSON.parse(existingCart);
        if (!Array.isArray(cartArray)) cartArray = [];
      }
      
      // Check if item already exists in cart
      const existingItemIndex = cartArray.findIndex(item => item.id === product.id);
      let newQuantity = 1;
      
      if (existingItemIndex >= 0) {
        // Increment quantity if already in cart
        newQuantity = (cartArray[existingItemIndex].quantity || 1) + 1;
        cartArray[existingItemIndex].quantity = newQuantity;
      } else {
        // Add new item to cart
        const cartItem = {
          id: product.id,
          name: product.name,
          price: product.price || 0,
          quantity: 1,
          imageUrl: product.imageUrl || product.image,
          image: product.imageUrl || product.image,
          deliverySpeed: product.deliverySpeed || 'normal',
          originalDeliverySpeed: product.deliverySpeed || 'normal'
        };
        
        cartArray.push(cartItem);
        newQuantity = 1;
      }
      
      // Update cartItems state to reflect changes
      setCartItems(prevState => ({
        ...prevState,
        [product.id]: newQuantity
      }));
      
      // Save updated cart to localStorage
      localStorage.setItem('cartItems', JSON.stringify(cartArray));
      
      // Also save to Firestore if user is logged in
      try {
        const authToken = localStorage.getItem('authToken');
        if (authToken) {
          // Get user info
          const userInfo = JSON.parse(localStorage.getItem('userData') || '{}');
          const userId = userInfo.uid;
          
          if (userId) {
            // Add to cart history in Firestore
            await addDoc(collection(db, 'cartHistory'), {
              userId: userId,
              productId: product.id,
              productName: product.name,
              price: product.price || 0,
              quantity: 1,
              addedAt: Timestamp.now(),
              source: 'wishlist'
            });
          }
        }
      } catch (firestoreError) {
        console.error("Error saving to Firestore:", firestoreError);
        // Continue execution even if Firestore fails
      }
      
      // Dispatch cart updated event
      const event = new Event('cartUpdated');
      window.dispatchEvent(event);
      
      // Show notification
      setNotification({
        show: true,
        message: `${product.name} added to cart (${newQuantity})`,
        type: 'success'
      });
      
      // Hide notification after 3 seconds
      setTimeout(() => {
        setNotification({ show: false, message: '', type: '' });
      }, 3000);
      
    } catch (error) {
      console.error("Error adding item to cart:", error);
      setError("Error adding item to cart. Please try again.");
    }
  };

  const handleUpdateCart = (product, change) => {
    try {
      // Get existing cart
      const existingCart = localStorage.getItem('cartItems');
      let cartArray = [];
      
      if (existingCart) {
        cartArray = JSON.parse(existingCart);
        if (!Array.isArray(cartArray)) cartArray = [];
      }
      
      // Find the item in the cart
      const existingItemIndex = cartArray.findIndex(item => item.id === product.id);
      
      if (existingItemIndex >= 0) {
        const currentQuantity = cartArray[existingItemIndex].quantity || 1;
        const newQuantity = Math.max(0, currentQuantity + change);
        
        if (newQuantity === 0) {
          // Remove item from cart if quantity becomes 0
          cartArray.splice(existingItemIndex, 1);
          
          // Update cartItems state
          setCartItems(prevState => {
            const newState = { ...prevState };
            delete newState[product.id];
            return newState;
          });
          
          // Show notification
          setNotification({
            show: true,
            message: `${product.name} removed from cart`,
            type: 'info'
          });
        } else {
          // Update quantity
          cartArray[existingItemIndex].quantity = newQuantity;
          
          // Update cartItems state
          setCartItems(prevState => ({
            ...prevState,
            [product.id]: newQuantity
          }));
          
          // Show notification
          setNotification({
            show: true,
            message: `${product.name} quantity updated (${newQuantity})`,
            type: 'success'
          });
        }
        
        // Save updated cart to localStorage
        localStorage.setItem('cartItems', JSON.stringify(cartArray));
        
        // Dispatch cart updated event
        const event = new Event('cartUpdated');
        window.dispatchEvent(event);
        
        // Hide notification after 3 seconds
        setTimeout(() => {
          setNotification({ show: false, message: '', type: '' });
        }, 3000);
      }
    } catch (error) {
      console.error("Error updating cart:", error);
      setError("Error updating cart. Please try again.");
    }
  };


  const handleGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(-1, { replace: true });
  };


  const handleClearAll = () => {
    setWishlistItems([]);
    localStorage.setItem('wishListItems', JSON.stringify([]));
    
    // Dispatch event to update floating action button
    const event = new Event('wishlistUpdated');
    window.dispatchEvent(event);
  };

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  };

  if (loading) {
    return (
      <div className="wishlist-container">
        <button className="go-back-btn2" onClick={handleGoBack}>
          <span className="go-back-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </span>
          <span>Go Back</span>
        </button>
        <h1 className="wishlist-title">MY WISHLIST</h1>
        <div className="loading-message">Loading wishlist items...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="wishlist-container">
        <button className="go-back-btn2" onClick={handleGoBack}>
          <span className="go-back-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </span>
          <span>Go Back</span>
        </button>
        <h1 className="wishlist-title">MY WISHLIST</h1>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (wishlistItems.length === 0) {
    return (
      <div className="wishlist-container">
        <button className="go-back-btn2" onClick={handleGoBack}>
          <span className="go-back-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </span>
          <span>Go Back</span>
        </button>
        <h1 className="wishlist-title">MY WISHLIST</h1>
        <div className="empty-wishlist">
          <p>Your wishlist is empty.</p>
          <Link to="/products" className="browse-products-btn">Browse Products</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="wishlist-container">


      <button className="go-back-btn2" onClick={handleGoBack}>
        <span className="go-back-icon" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </span>
        <span>Go Back</span>
      </button>
      {/* Notification */}
      {notification.show && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}
      
      <div className="wishlist-header">
        <h1 className="wishlist-title">MY WISHLIST</h1>
        <div className="wishlist-actions">
          <div className="sort-controls">
            <select 
              className="sort-select" 
              value={sortBy} 
              onChange={handleSortChange}
              aria-label="Sort wishlist by"
            >
              <option value="name">Sort by Name</option>
              <option value="price">Sort by Price</option>
            </select>
            <button 
              className="sort-order-btn" 
              onClick={toggleSortOrder}
              aria-label={`Sort ${sortOrder === 'asc' ? 'ascending' : 'descending'}`}
            >
              {sortOrder === 'asc' ? '↑' : '↓'}
            </button>
          </div>
          <button className="clear-all-btn" onClick={handleClearAll}>
            Clear All
          </button>
        </div>
      </div>

      <div className="wishlist-items">
        {wishlistItems.map(item => (
          <div key={item.id} className="wishlist-item">
            <div className="wishlist-item-image">
              <img 
                src={item.imageUrl || item.image || "/images/product-placeholder.jpg"} 
                alt={item.name}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/product-placeholder.jpg";
                }}
              />
            </div>
            <div className="wishlist-item-details">
              <h3 className="wishlist-item-name">{item.name}</h3>
              <p className="wishlist-item-price">₹{parseFloat(item.price).toFixed(2)}</p>
              <p className="wishlist-item-desc">{item.description || "No description available."}</p>
            </div>
            <div className="wishlist-item-actions">
              {cartItems[item.id] ? (
                <div className="cart-quantity-control">
                  <span className="in-cart-label">In Cart:</span>
                  <div className="quantity-control">
                    <button 
                      className="quantity-btn decrease"
                      onClick={() => handleUpdateCart(item, -1)}
                    >
                      -
                    </button>
                    <span className="quantity-display">{cartItems[item.id]}</span>
                    <button 
                      className="quantity-btn increase"
                      onClick={() => handleUpdateCart(item, 1)}
                    >
                      +
                    </button>
                  </div>
                </div>
              ) : (
                <button 
                  className="add-to-cart-btn"
                  onClick={() => handleAddToCart(item)}
                >
                  Add to Cart
                </button>
              )}
              <button 
                className="remove-wishlist-btn"
                onClick={() => handleRemoveItem(item.id)}
                aria-label={`Remove ${item.name} from wishlist`}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wishlist;